import React, { Component } from 'react';
import { Grid, Icon, Popup } from 'semantic-grab-ui/src';
import _ from 'lodash';
import moment from 'moment';
import { changeTypeToAuditResourceType, campaignChangeTypes } from 'data/trident-types';
import './VersionHistoryList.scss';

interface Props {
  records: Array<{ time: string; editor: string; changeType: string }>;
  campaignID: string;
  auditLogHost: string;
  auditLogIndex: string;
  changeTypeToResourceType: (string) => string;
}

// VersionHistoryList shows Trident campaign version history records in list view
export default class VersionHistoryList extends Component<Props> {
  getAuditLogLink = (host: string, index: string, time: string, campaignID: string, changeType: string): string => {
    const resourceType = this.props.changeTypeToResourceType ?
      this.props.changeTypeToResourceType(changeType)
      : _.get(changeTypeToAuditResourceType, changeType);
    const fromTimeStr = moment(time).utc().subtract(1, 'minutes').format();
    const toTimeStr = moment(time).utc().add(1, 'minutes').format();

    const url = `
    https://${host}/app/kibana#/discover?
    _g=
    (
      refreshInterval:(pause:!t,value:0),
      time:(
        from:'${fromTimeStr}',
        mode:absolute,
        to:'${toTimeStr}'
      )
    )&
    _a=(
      columns:!(_source),
      filters:!(
        (
          '$state':(store:appState),
          meta:(
            alias:!n,
            disabled:!f,
            index:'${index}',
            key:resource_type,
            negate:!f,
            params:(query:${resourceType},type:phrase),
            type:phrase,
            value:${resourceType}
          ),
          query:(
            match:(
              resource_type:(query:${resourceType},type:phrase)
            )
          )
        ),
        (
          '$state':(store:appState),
          meta:(
            alias:!n,
            disabled:!f,
            index:'${index}',
            key:resource_id,
            negate:!f,
            params:(
              query:'${campaignID}',type:phrase
            ),
            type:phrase,
            value:'${campaignID}'
          ),
          query:(
            match:(
              resource_id:(query:'${campaignID}',type:phrase)
            )
          )
        )
      ),
      index:'${index}',
      interval:auto,
      query:(language:lucene,query:''),
      sort:!(modified_at,desc)
    )`;

    return url.replace(/\s/g, '');
  }

  getChangeTypeSpan = (changeType: string): JSX.Element => {
    return <span className={`change-type ${changeType}`}>{changeType}</span>;
  };

  getFormattedTime = (time: string): string => {
    if (_.isEmpty(time)) {
      return 'Unknown time';
    }
    return moment(time).format('MMM Do YYYY, h:mm:ss a');
  };

  render() {
    const records = _.get(this.props, 'records', []);
    const { auditLogHost, auditLogIndex, campaignID } = this.props;

    return (
      <Grid>
        {
          records.map(
            (value, index) => {
              return (
                <Grid.Row key={index}>
                  <Grid.Column width={11}>
                    <h5>{this.getFormattedTime(value.time)}</h5>
                    <Icon fitted name="marker" color="green" /> &nbsp;<span>{value.editor}</span>
                  </Grid.Column>
                  <Grid.Column width={5}>
                    {
                      (value.changeType === campaignChangeTypes.create || value.changeType === campaignChangeTypes.update || value.changeType === campaignChangeTypes.patch) ?
                        <Popup
                          content="Click to view audit log"
                          trigger={
                            <a target="_blank" href={this.getAuditLogLink(auditLogHost, auditLogIndex, value.time, campaignID, value.changeType)}>
                              {this.getChangeTypeSpan(value.changeType)}
                            </a>
                          }
                        />
                        :
                        this.getChangeTypeSpan(value.changeType)
                    }
                  </Grid.Column>
                </Grid.Row>
              );
            }
          )
        }
      </Grid>
    );
  }
}
